// Ruta /play — mesa de juego principal (Sprint 3+4+5+6+8).
// Integra el GameBoard con gameStore + toasts + anuncios accesibles +
// autosave cada 30s + link a /saves + i18n + tutorial.

import { useEffect } from 'react';
import { createFileRoute, Link } from '@tanstack/react-router';
import { GameBoard } from '../components/GameBoard';
import { ToastViewport } from '../components/ToastViewport';
import { PhaseAnnouncer } from '../lib/useGamePhase';
import { startAutosave } from '../store/gameStore';
import { Tutorial } from '../components/Tutorial';
import { useT } from '../lib/i18n';

export const Route = createFileRoute('/play')({
  component: PlayPage,
});

function PlayPage() {
  const t = useT();
  useEffect(() => {
    const stop = startAutosave();
    return stop;
  }, []);

  return (
    <main id="main-content" className="min-h-screen bg-bg text-text">
      <div className="border-b border-border bg-bg-alt/40">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 md:px-6">
          <Link to="/" className="text-sm text-text-muted transition hover:text-gold">
            {t('common.back')}
          </Link>
          <Link to="/play" className="font-display text-lg text-gold" aria-label={t('app.name')}>
            Regicide
          </Link>
          <div className="flex items-center gap-3 text-sm">
            <Link to="/saves" className="text-text-muted transition hover:text-gold">
              Saves
            </Link>
            <Link
              to="/settings"
              className="text-text-muted transition hover:text-gold"
              aria-label={t('settings.title')}
            >
              ⚙
            </Link>
          </div>
        </div>
      </div>
      <GameBoard />
      <ToastViewport />
      <PhaseAnnouncer />
      <Tutorial />
    </main>
  );
}
